// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__BAgb7","wrapper":"styles_wrapper__9idfr"};